module.exports = __webpack_public_path__ + "static/img/partner_14.e500617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/partners/partner_14.png
// module id = usFP
// module chunks = 0